import { render, staticRenderFns } from "./outOfStockProduct.vue?vue&type=template&id=299c8fc2"
import script from "./outOfStockProduct.vue?vue&type=script&lang=js"
export * from "./outOfStockProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports